<template>
<div class="form-part">
  <div class="row">
    <div class="col-2 label-left">
      <b-form-checkbox v-model="fields.pis_mode_sel" class="mt-1">Obs. Mode</b-form-checkbox>
    </div>
    <div class="col-4">
      <b-form-input v-model="fields.pis_mode" class="fits-width"></b-form-input>
    </div>
  </div>

  <div class="row">
    <div class="col-2 label-left">
      <b-form-checkbox v-model="fields.pis_pixscale_sel" class="mt-1">Pixel Scale</b-form-checkbox>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">Min:</label>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.pis_pixscale_min"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.pis_pixscale_min">{{fieldErrors.pis_pixscale_min}}</span>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">Max:</label>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.pis_pixscale_max"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.pis_pixscale_max">{{fieldErrors.pis_pixscale_max}}</span>
    </div>
  </div>
</div>
</template>

<script>
import {
  mapState
} from 'vuex';

export default {
  name: 'Pisces',
  computed: mapState({
    fields: state => state.searchForm.fields,
    fieldErrors: state => state.searchForm.fieldErrors
  })
}
</script>
